import type { ErrorComponentProps } from "@tanstack/react-router";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { ErrorState } from "@/components/brand/error-state";
import { reportClientError } from "@/lib/observability";

export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  useEffect(() => {
    void reportClientError(error, "route");
  }, [error]);
  return (
    <div className="mx-auto max-w-lg px-4 py-16">
      <ErrorState
        description={
          import.meta.env.DEV
            ? error.message
            : "It has been recorded and The Motherhood can see it. Try again, or come back in a moment."
        }
        onRetry={() => {
          reset();
          void router.invalidate();
        }}
      />
    </div>
  );
}
